import vue from "../main";

export const allAccommodationSettlementTypes = () => {
  return [
    {
      value: 1,
      text: vue.$t("$staticData.accommodationSettlementTypes.importReservation")
    },
    {
      value: 3,
      text: vue.$t("$staticData.accommodationSettlementTypes.invoiceCompanyPayment")
    },
    {
      value: 2,
      text: vue.$t("$staticData.accommodationSettlementTypes.invoiceWorkerPayment")
    },
    {
      value: 4,
      text: vue.$t("$staticData.accommodationSettlementTypes.lumpSum")
    },
    {
      value: 5,
      text: vue.$t("$staticData.accommodationSettlementTypes.employeeStatement")
    },
    {
      value: 6,
      text: vue.$t("$staticData.accommodationSettlementTypes.alreadySettled")
    }
  ];
};

export default function() {
  let allowedAccommodationSettlementTypes = JSON.parse(vue.$store.state.Auth.userProperties.system_settings.allowed_accommodation_settlement);
  return allAccommodationSettlementTypes().filter(row => allowedAccommodationSettlementTypes.includes(row.value));
}
